import axios from "axios";
import { IS_LOCAL_DEV, APP_ORIGIN } from "./env";

// La API es SIEMPRE same-origin (/api en el propio dominio): la plataforma enruta
// /api al backend en todos los entornos. REACT_APP_BACKEND_URL solo se honra en
// desarrollo local (localhost), donde no hay ingress. Por diseño, un build de
// producción jamás puede llamar al backend de preview aunque la variable de entorno
// quedara mal inyectada en el build.
const envBase = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
let envOrigin = null;
try {
  envOrigin = envBase ? new URL(envBase).origin : null;
} catch {
  envOrigin = null;
}
if (!IS_LOCAL_DEV && envOrigin && envOrigin !== APP_ORIGIN) {
  // Diagnóstico para soporte: el build lleva config de otro entorno. No se usa jamás.
  console.error(
    `[Asset Passport] Build con API de otro origen (${envOrigin}) servido desde ${APP_ORIGIN}. ` +
      "Ignorada por seguridad: se usa same-origin /api."
  );
}
export const API = IS_LOCAL_DEV && envBase ? `${envBase}/api` : "/api";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Endpoints públicos: un 401 aquí (p. ej. contraseña incorrecta) NO es sesión caducada.
const PUBLIC_API_PATHS = ["/auth/login", "/auth/2fa/verify", "/auth/forgot-password", "/auth/reset-password", "/auth/activate", "/pilot-requests"];

api.interceptors.response.use(
  (res) => {
    const exp = res.headers?.["x-session-exp"];
    if (exp) {
      localStorage.setItem("ap_session_exp", exp);
      window.dispatchEvent(new Event("session:exp"));
    }
    return res;
  },
  (err) => {
    const url = err?.config?.url || "";
    if (err?.response?.status === 401 && !PUBLIC_API_PATHS.some((p) => url.includes(p))) {
      window.dispatchEvent(new Event("auth:expired"));
    }
    return Promise.reject(err);
  }
);

export function fmtErr(e, fallback = "Ha ocurrido un error. Inténtalo de nuevo.") {
  const detail = e?.response?.data?.detail;
  if (detail == null) {
    if (e?.code === "ERR_NETWORK" || e?.message === "Network Error") {
      return "No se pudo conectar con el servidor. Comprueba tu conexión e inténtalo de nuevo.";
    }
    if (e?.code === "ECONNABORTED") {
      return "La solicitud tardó demasiado. Inténtalo de nuevo.";
    }
    return e?.message || fallback;
  }
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fileUrl = (path) => `${API}/files/${path}`;

export const machinePhotoSrc = (m) =>
  m?.photo_path ? fileUrl(m.photo_path) : m?.photo_url || null;

export const assetSrc = (item) =>
  item?.storage_path ? fileUrl(item.storage_path) : item?.external_url || null;

export function formatSize(bytes) {
  if (!bytes) return "";
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
